import Field from "formiojs/components/_classes/field/Field";
import "bootstrap/dist/css/bootstrap.min.css";
import config from "../../config/config";
export default class ImageSelectorV1 extends Field {
  static schema(...extend) {
    return Field.schema({
      type: "imageselectorV1",
      label: "Bitte wählen Sie ein passendes Logo",
      key: "imageSelectorV1",
      buttonStyle: "btn-primary",
      description: "",
      buttonLabel: "Select Logo V1",
      changeLabel: "Change Logo",
      removeLabel: "Remove Logo",

      // Rollen, die den ImageSelector sehen dürfen
    allowedRoles: {
      SYSTEM_ADMIN: true,
      COMMUNITY_ADMIN: true,
      COMMUNITY_MEMBER: false,
      TESTER: false,
      FORM_BUILDER: false,
    },

      ...extend,
    });
  }

  static get builderInfo() {
    return {
      title: "Image Selector V1",
      icon: "fa fa-picture-o",
      group: "basic",
      weight: 70,
      schema: ImageSelectorV1.schema(),
    };
  }

  // ⬇️ Use default edit form + extend it
 static editForm(...extend) {

    const baseEditForm = Field.editForm(...extend);

    const displayTab =
      baseEditForm.components?.[0]?.components?.find(
        (panel) => panel.key === "display"
      ) ||
      baseEditForm.components?.find(
        (panel) => panel.key === "display"
      );

    if (displayTab && Array.isArray(displayTab.components)) {
      displayTab.components.push(
        {
          type: "textfield",
          key: "buttonLabel",
          label: "Button Label (When No Logo Selected)",
          input: true,
          weight: 110,
        },
        {
          type: "textfield",
          key: "changeLabel",
          label: "Change Logo Button Label",
          input: true,
          weight: 111,
        },
        {
          type: "textfield",
          key: "removeLabel",
          label: "Remove Logo Button Label",
          input: true,
          weight: 112,
        },
        {
          type: "selectboxes",
          input: true,
          key: "allowedRoles",
          label: "Sichtbar für Rollen",
          tooltip: "Legt fest, welche OZG-Manager-Rollen den ImageSelector sehen dürfen.",
          weight: 113,
          defaultValue: {
            SYSTEM_ADMIN: true,
            COMMUNITY_ADMIN: true,
            COMMUNITY_MEMBER: false,
            TESTER: false,
            FORM_BUILDER: false,
          },
          values: [
            {
              label: "System Administrator",
              value: "SYSTEM_ADMIN",
              shortcut: "",
            },
            {
              label: "Gemeinde Administrator",
              value: "COMMUNITY_ADMIN",
              shortcut: "",
            },
            {
              label: "Gemeinde Mitarbeiter",
              value: "COMMUNITY_MEMBER",
              shortcut: "",
            },
            {
              label: "Tester",
              value: "TESTER",
              shortcut: "",
            },
            {
              label: "Formular Ersteller",
              value: "FORM_BUILDER",
              shortcut: "",
            },
          ],
        }
      );
    } else {
      console.warn("[ImageSelectorV1] Display-Tab im editForm nicht gefunden", baseEditForm);
    }

    return baseEditForm;
  }

  get defaultSchema() {
    return ImageSelectorV1.schema();
  }

  constructor(...args) {
    super(...args);
    this.images = [];
    this.totalCount = 0;
    this.offset = 0;
    this.limit = 20;
    this.searchKeyword = "";
    this.viewType = "grid";
  }

    getValueByPath(obj, path) {
    if (!obj || !path) return null;

    // 1. zuerst flachen Key prüfen
    if (Object.prototype.hasOwnProperty.call(obj, path)) {
      return obj[path];
    }

    // 2. danach Punktnotation prüfen
    return path.split(".").reduce((current, key) => {
      return current && current[key] !== undefined ? current[key] : null;
    }, obj);
  }

  normalizeImageValue(value) {
    if (!value) return null;

    if (typeof value === "string") {
      return value;
    }

    if (typeof value === "object") {
      return (
        value.url ||
        value.src ||
        value.filePath ||
        value.path ||
        value.value ||
        null
      );
    }

    return null;
  }

  getSelectedImageValue() {
    let value = this.dataValue;

    if (!value && this.root && this.root.submission && this.root.submission.data) {
      value = this.getValueByPath(this.root.submission.data, this.component.key);
    }

    if (!value && this.data) {
      value = this.getValueByPath(this.data, this.component.key);
    }

    return this.normalizeImageValue(value);
  }

  refreshPreview() {
    const selectedImage = this.getSelectedImageValue();

    const preview = this.element?.querySelector(".selected-image-preview");
    if (preview) {
      preview.innerHTML = selectedImage
        ? `<img src="${selectedImage}" style="max-width: 150px;" />`
        : "";
    }

    const btn = this.element?.querySelector(".select-image-btn");
    if (btn) {
      btn.textContent = selectedImage
        ? this.component.changeLabel || "Change Logo"
        : this.component.buttonLabel || this.component.label || "Select Logo V1";
    }

    let removeBtn = this.element?.querySelector(".remove-image-btn");

    if (selectedImage && !removeBtn && btn && btn.parentNode) {
      removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "btn btn-danger ms-2 remove-image-btn";
      removeBtn.textContent = this.component.removeLabel || "Remove Logo";

      btn.parentNode.insertBefore(removeBtn, btn.nextSibling);

      this.addEventListener(removeBtn, "click", () => {
        this.dataValue = null;

        if (this.data && this.component?.key) {
          this.data[this.component.key] = null;
        }

        if (this.root?.submission?.data && this.component?.key) {
          this.root.submission.data[this.component.key] = null;
        }

        this.updateValue(null);
        this.triggerChange();
        this.redraw();
      });
    }

    if (!selectedImage && removeBtn) {
      removeBtn.remove();
    }
  }

  setValue(value, flags = {}) {
    const changed = super.setValue(value, flags);

    if (value) {
      this.dataValue = value;

      if (this.data && this.component?.key) {
        this.data[this.component.key] = value;
      }

      if (this.root?.submission?.data && this.component?.key) {
        this.root.submission.data[this.component.key] = value;
      }
    }

    setTimeout(() => {
      this.refreshPreview();
    }, 0);

    return changed;
  }

    render() {
    const selectedImage = this.getSelectedImageValue();

    console.log("[ImageSelectorV1][render]", {
      key: this.component.key,
      dataValue: this.dataValue,
      selectedImage,
      data: this.data,
      submission: this.root?.submission?.data
    });

    return super.render(`
      <div>
        <button type="button" 
                class="btn ${
                  this.component.buttonStyle || "btn-primary"
                } select-image-btn">
          ${
            selectedImage
              ? this.component.changeLabel || "Change Logo"
              : this.component.buttonLabel ||
                this.component.label ||
                "Select Logo V1"
          }
        </button>
        ${
          selectedImage
            ? `<button type="button" class="btn btn-danger ms-2 remove-image-btn">
                ${this.component.removeLabel || "Remove Logo"}
               </button>`
            : ""
        }
        ${
          this.component.description
            ? `<p>${this.component.description}</p>`
            : ""
        }
        <div class="selected-image-preview mt-2">
          ${
            selectedImage
              ? `<img src="${selectedImage}" style="max-width: 150px;" />`
              : ""
          }
        </div>
      </div>
    `);
  }

  attach(element) {
    super.attach(element);

    const selectedImage = this.getSelectedImageValue();

    if (selectedImage && !this.dataValue) {
      this.dataValue = selectedImage;
      this.updateValue(selectedImage, { noValidate: true });
    }

    setTimeout(() => {
      this.refreshPreview();
    }, 0);

    setTimeout(() => {
      this.refreshPreview();
    }, 100);

    const isBuilderOrEditor =
      !!this.builderMode ||
      !!this.options?.builder ||
      !!this.root?.builderMode ||
      !!this.root?.options?.builder ||
      !!element.closest(".formio-builder") ||
      !!element.closest(".formio-dialog") ||
      !!element.closest(".formio-component-edit");

    if (!isBuilderOrEditor) {
      const allowedRolesConfig = this.component.allowedRoles || {
        SYSTEM_ADMIN: true,
        COMMUNITY_ADMIN: true,
      };

      const allowedRoles = Array.isArray(allowedRolesConfig)
        ? allowedRolesConfig
        : Object.keys(allowedRolesConfig).filter(
            (role) => allowedRolesConfig[role]
          );

      const currentUser = window.currentUser || {};
      const userGroups = Array.isArray(currentUser.groups)
        ? currentUser.groups
        : [];

      const hasAllowedRole = userGroups.some((role) =>
        allowedRoles.includes(String(role).trim())
      );

      if (!hasAllowedRole) {
        const wrapper =
          element.closest(".formio-component") ||
          element.closest(".formio-component-imageselectorV1") ||
          element;

        if (wrapper) {
          wrapper.style.display = "none";
        }

        return element;
      }
    }

    const selectBtn = element.querySelector(".select-image-btn");
    if (selectBtn) {
      this.addEventListener(selectBtn, "click", () => this.openModal());
    }

    const removeBtn = element.querySelector(".remove-image-btn");
    if (removeBtn) {
      this.addEventListener(removeBtn, "click", () => {
        this.dataValue = null;
        this.updateValue(null);
        this.triggerChange();
        this.redraw();
      });
    }

    return element;
  }

  openModal() {
    const oldModal = document.querySelector(".image-selector-modal");
    if (oldModal) oldModal.remove();

    const modal = document.createElement("div");
    modal.className = "modal fade show image-selector-modal";
    modal.style.display = "block";
    modal.style.background = "rgba(0,0,0,0.5)";
    modal.tabIndex = -1;

    modal.innerHTML = `
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Select Logo V1</h5>
        <button type="button" class="btn-close close-modal-btn" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-2 d-flex justify-content-between align-items-center">
          <input type="text" class="form-control search-input w-50" placeholder="Search logos..." />
          <div class="btn-group view-toggle ms-2" role="group">
            <button type="button" class="btn btn-outline-secondary active" data-view="grid">Grid</button>
            <button type="button" class="btn btn-outline-secondary" data-view="list">List</button>
            <button type="button" class="btn btn-outline-secondary" data-view="medium">Medium</button>
          </div>
        </div>
        <div>Total images: <span class="total-count">0</span></div>
        <div class="image-list d-flex flex-wrap"></div>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <div>
            <select class="form-select page-size-select" style="width: auto; display: inline-block;">
              ${[10, 20, 50, 100]
                .map(
                  (size) =>
                    `<option value="${size}" ${
                      size === this.limit ? "selected" : ""
                    }>${size}</option>`
                )
                .join("")}
            </select>
            <span class="current-page-info ms-2">Page 1</span>
          </div>
          <div class="btn-group pagination-controls" role="group">
            <button type="button" class="btn btn-secondary prev-btn">Previous</button>
            <button type="button" class="btn btn-secondary next-btn">Next</button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary close-modal-btn-footer">Close</button>
      </div>
    </div>
  </div>
`;
    // Inject CSS if not already injected
    if (!document.getElementById("image-selector-modal-styles")) {
      const style = document.createElement("style");
      style.id = "image-selector-modal-styles";
      style.textContent = `
    .image-selector-modal {
      overflow-y: auto;
    }

    .image-selector-modal .modal-dialog {
      max-width: 90%;
      max-height: 90vh;
      margin: 1.75rem auto;
    }

    .image-selector-modal .modal-content {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .image-selector-modal .modal-body {
      flex: 1 1 auto;
      overflow-y: auto;
      padding: 1rem;
      max-height: calc(90vh - 120px);
       scroll-behavior: smooth;
    }

    .image-selector-modal .image-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

  `;
      document.head.appendChild(style);
    }

    document.body.appendChild(modal);

    modal
      .querySelector(".close-modal-btn")
      .addEventListener("click", () => modal.remove());

    modal
      .querySelector(".close-modal-btn-footer")
      .addEventListener("click", () => modal.remove());

    modal.querySelector(".search-input").addEventListener("input", (e) => {
      this.searchKeyword = e.target.value;
      this.offset = 0;
      this.loadImages(modal);
    });

    modal.querySelector(".page-size-select").addEventListener("change", (e) => {
      this.limit = parseInt(e.target.value, 10);
      this.offset = 0;
      this.loadImages(modal);
    });

    modal.querySelector(".prev-btn").addEventListener("click", () => {
      if (this.offset >= this.limit) {
        this.offset -= this.limit;
        this.loadImages(modal);
      }
    });

    modal.querySelector(".next-btn").addEventListener("click", () => {
      if (this.offset + this.limit < this.totalCount) {
        this.offset += this.limit;
        this.loadImages(modal);
      }
    });

    modal.querySelectorAll(".view-toggle button").forEach((btn) => {
      btn.addEventListener("click", () => {
        modal
          .querySelectorAll(".view-toggle button")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        this.viewType = btn.dataset.view;
        this.renderImages(modal);
      });
    });

    this.loadImages(modal);
  }

  async loadImages(modal) {
    const listDiv = modal.querySelector(".image-list");
    listDiv.innerHTML = "Loading...";

    const { images, totalCount } = await this.fetchImages();
    this.images = images;
    this.totalCount = totalCount;

    modal.querySelector(".total-count").textContent = totalCount;

    const currentPage = Math.floor(this.offset / this.limit) + 1;
    const totalPages = Math.ceil(totalCount / this.limit);
    modal.querySelector(
      ".current-page-info"
    ).textContent = `Page ${currentPage} of ${totalPages || 1}`;

    const prevBtn = modal.querySelector(".prev-btn");
    const nextBtn = modal.querySelector(".next-btn");
    prevBtn.disabled = this.offset === 0;
    nextBtn.disabled = this.offset + this.limit >= totalCount;

    this.renderImages(modal);
  }

  renderImages(modal) {
    const listDiv = modal.querySelector(".image-list");
    listDiv.innerHTML = "";

    if (!this.images.length) {
      listDiv.innerHTML = "<p>No images found.</p>";
      return;
    }

    this.images.forEach((img) => {
      const container = document.createElement("div");
      container.style.cursor = "pointer";
      container.className =
        this.viewType === "list"
          ? "w-100 d-flex align-items-center mb-2 border p-2"
          : "m-2";

      if (this.viewType === "grid") {
        container.style.width = "100px";
      } else if (this.viewType === "medium") {
        container.style.width = "150px";
      }

      const imgEl = document.createElement("img");
      imgEl.src = config.ICON_PANEL_APP_URL + img.url;
      imgEl.title = img.title;
      imgEl.style.width =
        this.viewType === "medium"
          ? "140px"
          : this.viewType === "grid"
          ? "90px"
          : "60px";
      imgEl.style.marginRight = "10px";

      container.appendChild(imgEl);
      if (this.viewType === "list" || this.viewType === "medium") {
        const title = document.createElement("span");
        title.textContent = img.title;
        container.appendChild(title);
      }

      container.addEventListener("click", () => {
        const fullUrl = config.ICON_PANEL_APP_URL + img.url;

        this.dataValue = fullUrl;

        if (this.data && this.component?.key) {
          this.data[this.component.key] = fullUrl;
        }

        if (this.root?.submission?.data && this.component?.key) {
          this.root.submission.data[this.component.key] = fullUrl;
        }

        this.updateValue(fullUrl);
        this.triggerChange();

        modal.remove();

        setTimeout(() => {
          this.refreshPreview();
        }, 0);

        this.redraw();
      });

      listDiv.appendChild(container);
    });
  }


  // Bishnu alter Code, localStorage speichert diese Werte nicht
  async fetchImages() {
    try {
      const currentUser = window.currentUser || {};
      const communityData = window.communityData || {};

      const payload = {
        community_id: currentUser.communityId ?? communityData._id ?? null,
        community_number: communityData.ars ?? null,
        community_identifier:
          currentUser.CommunityIdentifier ??
          window.communityIdentifier ??
          communityData.communityIdentifier ??
          null,
        email: currentUser.emailAddress ?? null,
        first_name: currentUser.firstName ?? null,
        last_name: currentUser.lastName ?? null,
        source_of_call: "OZG-MANAGER",
        remember_minutes: 7200,
      };

      if (!payload.community_id) {
        throw new Error("community_id fehlt in window.currentUser/window.communityData");
      }

      if (!payload.community_number) {
        throw new Error("community_number fehlt in window.communityData.ars");
      }

      if (!payload.email) {
        throw new Error("email fehlt in window.currentUser.emailAddress");
      }

      const tokenResponse = await fetch(config.ICON_PANEL_API_URL + "/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!tokenResponse.ok) {
        const errText = await tokenResponse.text();
        throw new Error("Token request failed: " + errText);
      }

      const tokenData = await tokenResponse.json();
      const token = tokenData?.data?.token || tokenData?.token;

      if (!token) {
        throw new Error("Token nicht in der Response gefunden");
      }

      const imageResponse = await fetch(config.ICON_PANEL_API_URL + "/icon/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          offset: this.offset,
          limit: this.limit,
          icon_type: "ICON",
          search_keyword: this.searchKeyword,
          sort_by: "name",
          order_direction: "ASC",
        }),
      });

      if (!imageResponse.ok) {
        const errText = await imageResponse.text();
        throw new Error("Image list request failed: " + errText);
      }

      const data = await imageResponse.json();

      return {
        images:
          data?.data?.icons?.map((icon) => ({
            url: icon.icon_path,
            title: icon.icon_name,
          })) || [],
        totalCount: data?.data?.iconCount || 0,
      };
    } catch (e) {
      console.error("Fetch logo failed", e);
      return { images: [], totalCount: 0 };
    }
  }
}
